import { inject, Injectable } from '@angular/core';
import { ClearAllFilters, NamedQuery, MetadataAndQueryURLsConfig, NamedQueryInit } from '@ddv/models';
import { cfbApiLocationToken, replaceHostInMetadataAndQueryURLsToken, trebekApiLocationToken } from '@ddv/named-queries';
import { Observable, ReplaySubject, Subject } from 'rxjs';

@Injectable()
export class SelectedWidgetRelayService {
    private readonly replaceHostInURLs = inject(replaceHostInMetadataAndQueryURLsToken);
    private readonly trebekApiLocation = inject(trebekApiLocationToken);
    private readonly cfbApiLocation = inject(cfbApiLocationToken);

    readonly isWidgetGlobal$: Observable<boolean>;
    readonly clearAllFilters$: Observable<ClearAllFilters>;

    private readonly isWidgetGlobalSubject: Subject<boolean> = new ReplaySubject<boolean>(1);
    private currentNamedQuery: NamedQuery | undefined;
    private readonly clearAllFiltersSubject: Subject<ClearAllFilters> = new ReplaySubject<ClearAllFilters>(1);

    private readonly config: MetadataAndQueryURLsConfig;

    constructor() {
        this.isWidgetGlobal$ = this.isWidgetGlobalSubject.asObservable();
        this.clearAllFilters$ = this.clearAllFiltersSubject.asObservable();
        this.config = {
            replaceHostInURLs: this.replaceHostInURLs,
            trebekApiLocation: this.trebekApiLocation,
            cfbApiLocation: this.cfbApiLocation,
        };
    }

    relayIsWidgetGlobal(isWidgetGlobal: boolean): void {
        this.isWidgetGlobalSubject.next(isWidgetGlobal);
    }

    // only called by live demo widget
    updateCurrentNamedQuery(namedQuery: NamedQuery | undefined): void {
        this.currentNamedQuery = namedQuery ?
            new NamedQuery(namedQuery as NamedQueryInit, this.config) :
            undefined;
    }

    // only used by grid visualizations
    getCurrentNamedQuery(): NamedQuery | undefined {
        return this.currentNamedQuery;
    }

    clearAllFilters(widgetId: number): void {
        this.clearAllFiltersSubject.next({ id: widgetId, clearAllFilters: true });
    }
}
